import MagaluService from '@magalu/webzord';
export var useFirebasePush = function (params, logger) {
    if (logger === void 0) { logger = console; }
    var event = (params || {}).event;
    if (event) {
        MagaluService.request({
            callback: function (result) {
                logger.debug('MagaluService Callback', result);
                logger.debug('payload', { event: event, params: params });
            },
            callbackId: "Firebase - Event: ".concat(event, " - ").concat(new Date().getTime()),
            serviceArgs: {
                eventName: event,
                eventParams: params,
            },
            serviceName: 'analytics.trackEvent',
        });
    }
};
